//when dom ready,no jquery
const collectionId = "295680999604";
// Renamed from `w` to avoid a global-scope `const w` collision with another theme
// script (SyntaxError killed the whole file). 2026-07-16.
const manualBoxWidths = [200, 300, 400, 500, 600, 700, 800, 1000, 1200, 1400, 1600, 1800];

function initManual() {
  fetchSectionHtml("", new URL(window.location.href), { dataType: "json" });
  document
    .querySelectorAll("select.manual-filter[data-filter-key]")
    .forEach((selectElement) => fetchFilterOptions(selectElement));
  const search = document.getElementById("manual-search");
  if (search) {
    let t;
    search.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleFilter();
      }
    });
    search.addEventListener("input", () => {
      clearTimeout(t);
      t = setTimeout(handleFilter, 450);
    });
  }
}
// Run whether the script executes before or after DOMContentLoaded.
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initManual);
} else {
  initManual();
}

function toggleMoreFilters() {
  const m = document.getElementById("more-filters");
  const b = document.getElementById("more-filters-btn");
  if (!m) return;
  const willShow = m.style.display === "none" || m.style.display === "";
  m.style.display = willShow ? "flex" : "none";
  if (b) b.setAttribute("aria-expanded", willShow ? "true" : "false");
}

function applyManual(url) {
  url.searchParams.set("page", 1);
  url.searchParams.set("section_id", sectionId);
  window.history.replaceState({}, "", url.pathname + url.search);
  fetchSectionHtml("", url, { dataType: "json" });
}

function handleSort(event) {
  const url = new URL(window.location.href);
  url.searchParams.set("sort_by", event.target.value);
  applyManual(url);
}

function handleFilter() {
  const url = new URL(window.location.href);
  document
    .querySelectorAll("select.manual-filter[data-filter-key]")
    .forEach((selectElement) => {
      const filterKey = selectElement.getAttribute("data-filter-key");
      if (!filterKey) return;
      const selectedValue = selectElement.value;
      if (selectedValue === "") {
        url.searchParams.delete("filter.p.m.custom." + filterKey);
      } else {
        url.searchParams.set("filter.p.m.custom." + filterKey, selectedValue);
      }
    });
  // one combined search box: all-digits -> UPC/barcode, otherwise product name
  url.searchParams.delete("filter.p.m.custom.title");
  url.searchParams.delete("filter.p.m.custom.barcode");
  const search = document.getElementById("manual-search");
  const q = search ? search.value.trim() : "";
  if (q) {
    if (/^\d{8,}$/.test(q)) {
      url.searchParams.set("filter.p.m.custom.barcode", q);
    } else {
      url.searchParams.set("filter.p.m.custom.title", q);
    }
  }
  applyManual(url);
}

function fetchFilterOptions(ele) {
  const filterKey = ele.getAttribute("data-filter-key");
  if (!filterKey) {
    return;
  }
  const placeholder = ele.getAttribute("data-placeholder");
  let url = "https://app.prexhobby.com/product/query-filter-options";
  url = url + "?collection_id=" + collectionId + "&filter_key=" + filterKey;
  fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      const html = template("select-options", {
        placeholder: placeholder || "Select",
        list: data.data,
      });
      ele.innerHTML = html;
    });
}
function fetchProductsHtml(search) {
  let url = "https://app.prexhobby.com/product/query-by-collection";

  if (search) {
    url = url + search + "&collection_id=" + collectionId;
  } else {
    url = url + "?collection_id=" + collectionId;
  }
  url = url + "&size=20";
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        data.data.content.forEach((item) => {
          if (!item.featuredImage) {
            return;
          }
          const list = [];
          manualBoxWidths.forEach((width) => {
            if (width < item.featuredImage.width) {
              list.push(
                item.featuredImage.url + "&width=" + width + " " + width + "w"
              );
            }
          });
          item.featuredImage.srcset = list.join(",");
        });
        const clonedUrl = new URL(window.location.href);
        clonedUrl.searchParams.delete("page");
        const filters = [];
        const keys = clonedUrl.searchParams.keys();
        const filterKeys = new Set();
        for (const key of keys) {
          if (key.indexOf("filter.") >= 0) {
            filterKeys.add(key);
          }
        }
        for (const key of filterKeys) {
          const values = clonedUrl.searchParams.getAll(key);
          for (const value of values) {
            filters.push({
              key,
              value,
              url: getFilterRemoveUrl(window.location.href, key, value),
            });
          }
        }

        const html = template("products", data.data);
        const list = getPagination(
          data.data.current,
          data.data.totalPages,
          clonedUrl
        );
        const paginationHtml = template("art-pagination", {
          list: list,
          current: data.data.current,
          totalPages: data.data.totalPages,
          totalElements: data.data.totalElements,
        });

        resolve({
          html: html,
          pagination: paginationHtml,
          totalElements: data.data.totalElements,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}
function fetchSectionHtml(sectionId, url, data) {
  if (!data || data.dataType !== "json") {
    //return
  }
  let search = url.search;
  const searchParams = new URLSearchParams(search);
  const mSortBy =
    searchParams.get("sort_by") || "custom.release_date-descending";

  if (!mSortBy || mSortBy.indexOf("custom.") < 0) {
    return new Promise((resolve, reject) => {
      resolve(false);
    });
  }
  searchParams.set("sort_by", mSortBy.replace("custom.", ""));
  search = "?" + searchParams.toString();
  const ele = document.getElementById(`manual-list`);
  const paginationEle = document.getElementById(`pagination`);
  const resultCountEle = document.getElementById(`result-count`);
  return new Promise((resolve, reject) => {
    fetchProductsHtml(search)
      .then((data) => {
        ele.innerHTML = data.html;
        if (paginationEle) {
          paginationEle.innerHTML = data.pagination;
        }
        if (resultCountEle) {
          resultCountEle.innerHTML = `${data.totalElements} manuals`;
        }
        resolve(true);
      })
      .catch((error) => {
        console.error(error);
        resolve(false);
      });
  });
}
function getPagination(currentPage, totalPages, url) {
  const pagination = [];
  const maxVisiblePages = 7;

  if (currentPage > 1) {
    pagination.push({
      part: `prev`,
      url: getPaginationUrl(url, currentPage - 1),
    });
  }

  if (totalPages <= maxVisiblePages) {
    for (let i = 1; i <= totalPages; i++) {
      pagination.push({
        part: i,
        url: getPaginationUrl(url, i),
      });
    }
  } else {
    if (currentPage <= 4) {
      for (let i = 1; i <= 5; i++) {
        pagination.push({
          part: i,
          url: getPaginationUrl(url, i),
        });
      }
      pagination.push({ part: "..." });
      pagination.push({
        part: totalPages,
        url: getPaginationUrl(url, totalPages),
      });
    } else if (currentPage > totalPages - 4) {
      pagination.push({ part: 1, url: getPaginationUrl(url, 1) });
      pagination.push({ part: "..." });
      for (let i = totalPages - 4; i <= totalPages; i++) {
        pagination.push({
          part: i,
          url: getPaginationUrl(url, i),
        });
      }
    } else {
      pagination.push({ part: 1, url: getPaginationUrl(url, 1) });
      pagination.push({ part: "..." });
      for (let i = currentPage - 2; i <= currentPage + 2; i++) {
        pagination.push({
          part: i,
          url: getPaginationUrl(url, i),
        });
      }
      pagination.push({ part: "..." });
      pagination.push({
        part: totalPages,
        url: getPaginationUrl(url, totalPages),
      });
    }
  }

  if (currentPage < totalPages) {
    pagination.push({
      part: `next`,
      url: getPaginationUrl(url, currentPage + 1),
    });
  }

  return pagination;
}
function getFilterRemoveUrl(url, key, value) {
  const clonedUrl = new URL(url);
  const searchParams = new URLSearchParams();
  for (const [k, v] of clonedUrl.searchParams) {
    if (k !== key || v !== value) {
      searchParams.append(k, v);
    }
  }
  return clonedUrl.pathname + "?" + searchParams.toString();
}
function getPaginationUrl(url, page) {
  const clonedUrl = new URL(url);
  clonedUrl.searchParams.set("page", page);
  return clonedUrl.pathname + clonedUrl.search;
}
